/**
 * Toggle for Google Reviews Custom Modal
 *
 * @since   1.0.0
 * @package uma
 */

(function($) {

	$('.reveal-google-reviews').click(function() {
		//$('body').addClass('google-reviews-inview'); /* freezing scrolling via css does not work*/
		$('body').css({'overflow-y' : 'hidden'});
		$(this).next().addClass('open');
	});

	$('.close-google-reviews').click(function() {
		//$('body').removeClass('google-reviews-inview'); /* freezing scrolling via css does not work*/
		$('body').css({'overflow-y' : ''});
		$('.google-reviews').removeClass('open');
	});

	$('.google-reviews.open').click(function() {
		//$('body').removeClass('google-reviews-inview'); /* freezing scrolling via css does not work*/
		$('body').css({'overflow-y' : ''});
		$('.google-reviews').removeClass('open');
	});

	$('.wp-google-review').each(function() {

		if ($(this).find( '.wp-google-name:contains("Richard Clagett")' ).length > 0) {
			$(this).addClass('hide');
		}

		if ($(this).find( '.wp-google-name:contains("fralson sanchez")' ).length > 0) {
			$(this).addClass('hide');
		}
	})

}(jQuery));